export const iconFontAwesomeMedicalHealthMaskFace = (
	<i className="fa-solid fa-mask-face"></i>
);
